import { PurchasePlanning } from '@/features/purchase-planning/purchase-planning';
import { AppLayout } from '@/layouts/app-layout';

export function PurchasePlanningPage() {
  return (
    <AppLayout>
      <PurchasePlanning />
    </AppLayout>
  );
}
